/**
 * Asynchronously loads the component for ReportsPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
